import Component from '../app/component'

export default class PostsGridComponent extends Component {
  constructor (el) {
    super(el)
    this.data = {
      page: 1
    }
  }

  init () {
    if (this.refs.loadMore) {
      this.refs.loadMore.addEventListener('click', (e) => this.loadMore(e))
    }
  }

  loadMore(e) {
    e.preventDefault()
    this.data.page++
    fetch(e.target.href)
      .then(res => res.text())
      .then(data => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, 'text/html')
        const gridEls = doc.querySelectorAll('.postsgrid-posts')
        Array.from(gridEls).forEach(el => {
          if (this.refs.actions) {
            this.el.insertBefore(el, this.refs.actions)
          }
          else {
            this.el.appendChild(el)
          }
        })
        // test new pagination
        const loadMoreEl = doc.querySelector('.postsgrid-loadmore')
        if (loadMoreEl) {
          this.refs.loadMore.href = loadMoreEl.href
        }
        else {
          this.el.removeChild(this.refs.actions)
        }
      })
  }
}
